<svg [ngClass]="class() + ' ' + size()" fill="currentColor" aria-hidden="true">
  <use
    [attr.href]="'/assets/icons/icons.svg#' + name()"
    [attr.xlink:href]="'/assets/icons/icons.svg#' + name()"
  ></use>
</svg>
